<template>
  <component
    :is="tag"
    :class="['iconLink', { 'iconLink--reversed': reversed }]"
    :to="to"
    :href="href"
    :target="target"
    :disabled="disabled"
    @click="onClick"
  >
    {{ text }}
    <span v-if="icon" :class="`icon-${icon}`" />
  </component>
</template>

<script>
export default {
  name: 'IconLink',
  props: {
    text: {
      type: String,
      default: null,
    },
    to: {
      type: String,
      default: undefined,
    },
    target: {
      type: String,
      default: undefined,
    },
    href: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tag() {
      if (this.to) {
        return 'nuxt-link';
      } else if (this.href) {
        return 'a';
      } else {
        return 'button';
      }
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss">
.iconLink {
  position: relative;
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 700;
  color: $cMain;
  display: flex;
  align-items: center;
  width: fit-content;

  span {
    font-size: 1rem;
    line-height: 1rem;
    margin-left: 0.6rem;
  }

  &--reversed {
    flex-direction: row-reverse;
    color: $cMainDark;

    span {
      margin-left: 0;
      margin-right: 1rem;
      color: $cSec;
      font-size: 2rem;
      line-height: 2rem;
    }
  }
}
</style>
